import React from 'react';
import { Spinner, Table } from 'react-bootstrap'

import DefaultButton from 'components/mycomponents/DefaultButton';
import { dateTimeFormat } from 'utils/FormatDate';

const Data = ({
    dataMain,
    actionDetail,
    numberStart,
    isLoading
}) => {
    return (
        <Table responsive striped hover bordered size="sm">
            <thead>
                <tr>
                    <th scope="col">No</th>
                    <th scope="col">ID Driver</th>
                    <th scope="col">Nama</th>
                    <th scope="col">No HP</th>
                    <th scope="col">Mulai</th>
                    <th scope="col">Selesai</th>
                    <th scope="col">Bus</th>
                    <th className="text-end" scope="col" width="6%">
                        Aksi
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    isLoading ? (<tr>
                        <td colSpan={6} align="center" valign="middle">
                            <Spinner animation="border  " className="me-2" />
                            <span className="fs-4">Loading ...</span>
                        </td>
                    </tr>) :
                    dataMain ? dataMain.map((val, idx) => {
                        const startTime = new Date(val.date_start + ' 06:00:00');
                        const endTime = new Date(val.date_stop + ' 09:00:00');
                        let start = '';
                        let stop = '';
                        if (new Date(val.dtstart) >= startTime && new Date(val.dtstart) <= endTime) {
                        }
                        start = val.dtstart ? dateTimeFormat(val.dtstart) : '';
                        stop = val.dtstop ? dateTimeFormat(val.dtstop) : '';
                        return (
                            <tr key={idx}>
                                <td>{numberStart + 1 + idx}</td>
                                <td>{val.vccode_driver}</td>
                                <td>{val.vcname}</td>
                                <td>{val.vcphone}</td>
                                <td>{start}</td>
                                <td>{parseFloat(val.bus_status) === 9 ? stop : ''}</td>
                                <td>{val.vcbus}</td>
                                <td className="text-end">
                                    <DefaultButton icon="info" title="Detail Data" variant="action" className="p-0 me-3" clickAction={actionDetail} clickParam={val.intid} />
                                </td>
                            </tr>
                        );
                    }) : (
                        <tr>
                            <td colSpan={6}>Data Tidak Tersedia.</td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
}

Data.propTypes = {}

export default Data;